var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnStrokeClose20X20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn_stroke_close_20x20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.99186893,9.28476215 L13.9301845,5.34644661 C14.1254466,5.15118446 14.4420291,5.15118446 14.6372912,5.34644661 C14.8325534,5.54170876 14.8325534,5.85829124 14.6372912,6.05355339 L10.6989757,9.99186893 L14.6372912,13.9301845 C14.8325534,14.1254466 14.8325534,14.4420291 14.6372912,14.6372912 C14.4420291,14.8325534 14.1254466,14.8325534 13.9301845,14.6372912 L9.99186893,10.6989757 L6.05355339,14.6372912 C5.85829124,14.8325534 5.54170876,14.8325534 5.34644661,14.6372912 C5.15118446,14.4420291 5.15118446,14.1254466 5.34644661,13.9301845 L9.28476215,9.99186893 L5.34644661,6.05355339 C5.15118446,5.85829124 5.15118446,5.54170876 5.34644661,5.34644661 C5.54170876,5.15118446 5.85829124,5.15118446 6.05355339,5.34644661 L9.99186893,9.28476215 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_stroke_close_20x20",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/stroke/close"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Colour",
    fill: "#666666",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStrokeClose20X20);
export default __webpack_public_path__ + "static/media/icn_stroke_close_20x20.38adb735230ad5ca13b3b1b6c1d97a6c.svg";
export { ForwardRef as ReactComponent };